import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=78565de4&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=78565de4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78565de4",
  null
  
)

export default component.exports